import { useParams, Link } from "react-router-dom";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import Breadcrumb from "@/components/feature/Breadcrumb";
import EmptyState from "@/components/feature/EmptyState";
import { categories } from "@/mocks/categories";
import { getContentsByCategory } from "@/utils/content";
import { usePageMeta } from "@/hooks/usePageMeta";
import CategoryExplorer from "./components/CategoryExplorer";

export default function CategoryPage() {
  const { categoryId = "" } = useParams();
  const category = categories.find((c) => c.id === categoryId);
  const items = getContentsByCategory(categoryId);

  usePageMeta(
    `${category?.name ?? "分类"} - 国语对白做受69`,
    category
      ? `${category.description}涵盖国语对白${category.name}资源，支持按地区、年份、类型多维筛选与排序。`
      : "国语对白做受69分类资源页",
    `${category?.name ?? "分类"},国语对白做受69,国语对白,影音资源,${category?.name ?? ""}资源`,
  );

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteNavbar />

      <main className="flex-1 w-full">
        {category ? (
          <section className="relative w-full h-52 md:h-64 overflow-hidden">
            <img
              src={category.cover}
              alt={`${category.name} 分类资源`}
              title={`${category.name} 国语对白影音资源`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/30" />
            <div className="absolute inset-0 flex items-end">
              <div className="mx-auto w-full max-w-page px-4 md:px-8 pb-6 md:pb-8">
                <Breadcrumb items={[{ label: "首页", to: "/" }, { label: category.name }]} />
                <div className="mt-3 flex items-center gap-3">
                  <span className="w-11 h-11 rounded-lg bg-accent-500 flex items-center justify-center shrink-0">
                    <i className={`${category.icon} text-background-50 text-xl`} />
                  </span>
                  <h1 className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
                    {category.name}
                  </h1>
                </div>
                <p className="mt-2.5 max-w-2xl text-sm text-background-200 leading-relaxed">
                  {category.description}
                </p>
              </div>
            </div>
          </section>
        ) : (
          <div className="mx-auto max-w-page px-4 md:px-8 pt-8">
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "分类不存在" }]} />
          </div>
        )}

        <div className="mx-auto max-w-page px-4 md:px-8 py-8 md:py-12">
          {category ? (
            <CategoryExplorer key={categoryId} items={items} />
          ) : (
            <EmptyState
              title="没有找到该分类"
              description="你访问的分类可能不存在或已调整，返回首页看看其他精彩内容吧。"
              actionLabel="返回首页"
              onAction={() => window.REACT_APP_NAVIGATE?.("/")}
            />
          )}
        </div>
      </main>

      <section className="w-full border-t border-background-200 bg-background-100">
        <div className="mx-auto max-w-page px-4 md:px-8 py-8 flex flex-wrap items-center gap-x-3 gap-y-2">
          <span className="text-sm text-foreground-500 mr-1">其他分类：</span>
          {categories
            .filter((c) => c.id !== categoryId)
            .map((c) => (
              <Link
                key={c.id}
                to={`/category/${c.id}`}
                className="flex items-center gap-1.5 rounded-full bg-background-50 border border-background-200 px-3.5 py-1.5 text-xs text-foreground-700 hover:border-accent-300 hover:text-accent-700 transition-colors cursor-pointer"
              >
                <i className={`${c.icon} text-accent-500`} />
                {c.name}
              </Link>
            ))}
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}